import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Avatar } from "@mui/material";
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { RedirectPageData } from "../../../utils/static-data/index.js";
import { api_urls } from "../../../utils/api-urls/index.js";

const AddCategory = ({ mode }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const stateData = location?.state?.stateData;

    const [categoryDetail, setCategoryDetail] = useState({ redirectPage: stateData ? stateData?.redirect_page : '', categoryName: stateData ? stateData?.category_name : '', status: stateData ? stateData?.status : '' });
    const [inputFieldError, setInputFieldError] = useState({ redirectPage: '', categoryName: '', categoryImage: '', status: '' });
    const [categoryImage, setCategoryImage] = useState({ file: stateData ? api_urls + stateData?.image : logo_icon, bytes: "" });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setCategoryDetail({ ...categoryDetail, [name]: value });
    };

    //* Handle Category Image
    const handleCategoryImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0]?.size < 1 * 1024 * 1024) {
                setCategoryImage({
                    file: URL.createObjectURL(e.target.files[0]),
                    bytes: e.target.files[0],
                });
            } else {
                alert("Please upload image having size less than 1 MB")
            }
        }

        handleInputFieldError("categoryImage", null)
    };

    //! Handle validation
    const handleValidation = () => {
        let isValid = true;
        const { redirectPage, categoryName, status } = categoryDetail;
        const { bytes } = categoryImage;

        if (!redirectPage) {
            handleInputFieldError("redirectPage", "Please Select Redirect Page")
            isValid = false;
        }
        if (!categoryName) {
            handleInputFieldError("categoryName", "Please Enter Category Name")
            isValid = false;
        }
        if (!bytes) {
            handleInputFieldError("categoryImage", "Please Select Image")
            isValid = false;
        }
        if (!status) {
            handleInputFieldError("status", "Please Select Status")
            isValid = false;
        }
        return isValid;
    };

    //! Handle Submit - Creating Category
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            console.log("Category Data :: ", { ...categoryDetail, categoryImage })
            const { redirectPage, categoryName, status } = categoryDetail;

            if (stateData) {

                let formData = new FormData();
                formData.append("categoryId", stateData?._id);
                formData.append("redirect_page", redirectPage);
                formData.append("category_name", categoryName);
                formData.append("image", categoryImage?.bytes);
                formData.append("status", status);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/category")
                }

                //! Dispatching API for Updating Category
                dispatch(CategoryActions.updateCategory(payload));

            } else {
                let formData = new FormData();
                formData.append("redirect_page", redirectPage);
                formData.append("category_name", categoryName);
                formData.append("image", categoryImage?.bytes);
                formData.append("status", status);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/category")
                }

                //! Dispatching API for Creating Category
                dispatch(CategoryActions.createCategory(payload))
            }
        }
    };

    return (

        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Category</div>
                    <div onClick={() => navigate("/category")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
                </div>

                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Category Name" variant='outlined' fullWidth
                            name='categoryName'
                            value={categoryDetail?.categoryName}
                            onChange={handleInputField}
                            error={inputFieldError.categoryName ? true : false}
                            helperText={inputFieldError.categoryName}
                            onFocus={() => handleInputFieldError("categoryName", null)}
                        />
                    </Grid>

                    <Grid item lg={6} sm={6} md={12} xs={12} >
                        <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                            <Grid item xs={2} >
                                <Avatar src={categoryImage.file} style={{ width: 40, height: 40 }} />
                            </Grid>
                            <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                                Upload Category Image
                                <input onChange={handleCategoryImage} hidden accept="image/*" type="file" />
                            </Grid>
                        </Grid>
                        {inputFieldError?.categoryImage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.categoryImage}</div>}
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <FormControl fullWidth>
                            <InputLabel id="select-label">Redirect Page</InputLabel>
                            <Select
                                label="Select Status" variant="outlined" fullWidth
                                name='redirectPage'
                                value={categoryDetail?.redirectPage}
                                onChange={handleInputField}
                                error={inputFieldError.redirectPage ? true : false}
                                onFocus={() => handleInputFieldError("redirectPage", null)}
                            >
                                <MenuItem disabled>---Select Redirect Page---</MenuItem>
                                {RedirectPageData.map((value, index) => (<MenuItem key={index} value={value}>{value}</MenuItem>))}
                            </Select>
                        </FormControl>
                        {inputFieldError?.redirectPage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.redirectPage}</div>}
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <FormControl fullWidth>
                            <InputLabel id="select-label">Select Status</InputLabel>
                            <Select
                                label="Select Status" variant="outlined" fullWidth
                                name='status'
                                value={categoryDetail?.status}
                                onChange={handleInputField}
                                error={inputFieldError.status ? true : false}
                                onFocus={() => handleInputFieldError("status", null)}
                            >
                                <MenuItem disabled>---Select Status---</MenuItem>
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive</MenuItem>
                            </Select>
                        </FormControl>
                        {inputFieldError?.status && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.status}</div>}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>

    );
};

export default AddCategory